import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class ConvexHull extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.convexhull',
        group: 'Spatial Operations',
        title: 'ST Convex Hull',
        description: `
      This component creates a new table containing a single row with the convex hull of geographies in the input table.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return dedent`SELECT ${connection.processOutputGeogColumn(
          `ST_CONVEXHULL(ST_UNION_AGG(${connection.processInputGeogColumn(params.geo as string)}))`
        )} geom
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT  /*+ REPARTITION(40, geom) */ ${connection.processOutputGeogColumn(
          `ST_CONVEXHULL(ST_UNION_AGG(${connection.processInputGeogColumn(params.geo as string)}))`
        )} geom
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT ST_CONVEXHULL(ST_COLLECT(${params.geo})) geom
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle: {
        const geoColumn = params.geo as string
        const outputColumn = 'geom'
        return dedent`SELECT SDO_GEOM.SDO_CONVEXHULL(
                (SELECT SDO_AGGR_UNION(SDOAGGRTYPE(${geoColumn}, 0.005)) 
                 FROM ${connection.quoteName(params.source as string)}),
                0.005
              ) ${outputColumn}`
      }
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ connection }: GetOutputSchemaParams): TableSchema {
    return [
      {
        name: 'geom',
        type: connection.getGeoDataType()
      }
    ]
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.DatabricksRest, Provider.Oracle]
  }
}

export { ConvexHull }
